import { useMemo } from 'react'
import { AuctionsHttpClient } from '@omnea-app/auctions/auctionsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'

// Returns an AuctionsHttpClient bound to the user's auth token, so each React Query hook doesn't
// re-create one
export const useAuctionsHttpClient = () => {
  const { getToken } = useAuthenticatedUser()

  return useMemo(() => new AuctionsHttpClient({ authorization: getToken }), [getToken])
}
